export default "__VITE_ASSET__D8eNMBfV__"